export default __webpack_public_path__ + "static/media/inox.c0dde32b.jpg";